@if (loader.isLoading) {
<div class="loader-class">
  <mat-spinner color="primary"></mat-spinner>
  <div class="loader-message">{{loader.message}}</div>
</div>
}
@if (errorMessage) {
<div class="error-container">
  <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
  <div class="loader-message">{{errorMessage}}</div>
</div>
}
@if (title) {
  <div class="header-section">
    <div class="header-title">
      {{title}}
    </div>
    <div class="cancel-icon">
      <mat-icon class="cross-icon" title="Close Popup" (click)="close()">cancel</mat-icon>
    </div>
  </div>
}
@if (!loader.hideTable && !errorMessage) {
  <div class="configuration-shell" [class.dialog-mode]="!!dialogData" [class.summary-mode]="!!dialogData?.isSummary">
    <section class="hero-panel">
      <div class="hero-copy">
        <h1 class="hero-title">{{pageTitle}}</h1>
        <p class="hero-description">{{pageDescription}}</p>
        <div class="hero-status-row">
          <div class="status-pill">
            <mat-icon>calendar_month</mat-icon>
            <span>{{selectedFiscalYear.displayName}}</span>
          </div>
          <div class="status-pill">
            <mat-icon>{{currentModeIcon}}</mat-icon>
            <span>{{currentModeLabel}}</span>
          </div>
          <div class="status-pill">
            <mat-icon>table_rows</mat-icon>
            <span>{{tableData.length}} records</span>
          </div>
          <div class="status-pill" [class.pending]="itemsToSave.size > 0">
            <mat-icon>pending_actions</mat-icon>
            <span>{{itemsToSave.size}} pending changes</span>
          </div>
        </div>
      </div>
      @if (showHeaderPanel) {
        <div class="hero-actions">
          <div class="control-card">
            <div class="section-label">Active Fiscal Year</div>
            <mat-form-field class="fiscal-year-field" appearance="outline">
              <mat-label>Fiscal Year</mat-label>
              <mat-select #fySelect [value]="selectedFiscalYear" (selectionChange)="onFiscalYearChange($event)">
                @for (year of fiscalYears; track year) {
                  <mat-option [value]="year">{{year.displayName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="control-support-text">
              Select a fiscal year to review or update the configuration set used by the calculator.
            </div>
          </div>
          @if (showSummaryButtons) {
            <div class="control-card">
              <div class="section-label">Quick Views</div>
              <div class="summary-button-grid">
                <p-button label="Plant Summary" icon="pi pi-chart-bar" [raised]="true" severity="secondary"
                  (onClick)="openSummary(plantSummary)"></p-button>
                <p-button label="Company Summary" icon="pi pi-building" [raised]="true"
                  (onClick)="openSummary(companySummary)"></p-button>
              </div>
              <div class="control-support-text">
                Open read-only rollups to compare shop values at the plant or company level.
              </div>
            </div>
          }
        </div>
      }
    </section>

    <section class="table-surface">
      <div class="table-surface-header">
        <div>
          <div class="section-label">Configuration Workspace</div>
        </div>
      </div>

      <div class="table-frame">
        <app-table-template [tableData]="tableData" [columnList]="columnList"
          [validateFn]="validateItem" [multiSortMeta]="multiSortMeta" sortMode="multiple"
          (actionButtonClicked)="handleButtonClicked($event)" [loading]="loader.isLoading"
          [editableTable]="editableTable" (pageDetails)="rewriteRouteQueryParams($event.page, $event.rows)"
          [page]="page" [rowsPerPage]="rowsPerPage" [rowsPerPageOptions]="rowsPerPageOptions">
          <div class="header-container">
            <div class="table-caption-note">
              <mat-icon>info</mat-icon>
              <span>
                @if (editableTable) {
                  Changes remain local until you select {{primaryActionLabel}}.
                }
                @else {
                  This fiscal year is read-only. You can review data, but updates are disabled.
                }
              </span>
            </div>
          </div>
        </app-table-template>
      </div>
    </section>

    <section class="footer-surface">
      @if (aggregationFields.length > 0) {
        <div class="metric-cluster">
          @for (field of aggregationFields; track field.name) {
            @if (!field.hidden) {
              <div class="metric-chip">
                <span class="metric-label">{{field.label}}</span>
                <span class="metric-value">{{field.valuePrefix}}{{field.value}}</span>
              </div>
            }
          }
        </div>
      }
      @if (showSubmitButtons && editableTable) {
        <div class="action-cluster">
          <p-button label="Discard Changes" icon="pi pi-times" [raised]="true" severity="secondary"
            (onClick)="onCancel()"></p-button>
          <p-button [label]="primaryActionLabel" icon="pi pi-check" [raised]="true"
            (onClick)="onSubmit()"></p-button>
        </div>
      }
      @else if (!editableTable) {
        <div class="readonly-note">
          <mat-icon>lock_clock</mat-icon>
          <span>Editing is disabled for past fiscal years.</span>
        </div>
      }
    </section>
  </div>
}